import { useEffect } from 'react'

/**
 * 세로 스크롤 가능한 요소인지 (overflow auto/scroll + 내용이 넘침).
 */
function canScrollVertically(el: HTMLElement): boolean {
  const style = window.getComputedStyle(el)
  const oy = style.overflowY
  return (
    (oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1
  )
}

/**
 * 가로 스크롤 가능한 요소인지 (overflow auto/scroll + 내용이 넘침).
 * 리뷰 사진 캐러셀처럼 가로로 스와이프하는 영역을 배경 스크롤 잠금에서 제외하기 위함.
 */
function canScrollHorizontally(el: HTMLElement): boolean {
  const style = window.getComputedStyle(el)
  const ox = style.overflowX
  return (
    (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1
  )
}

/**
 * 바텀시트/모달이 열린 동안 배경 화면 스크롤을 완전히 잠근다.
 * - 시트 내부의 실제 스크롤 영역(친구 목록 등)에서 시작한 터치는 그대로 허용
 * - 그 외(오버레이/핸들/배경 어디든)에서의 터치무브는 preventDefault로 배경 스크롤 차단
 *
 * React의 onTouchMove는 passive라 preventDefault가 무시되므로 non-passive 네이티브 리스너로 처리.
 * active=false면 아무것도 하지 않음.
 */
export function useBackgroundScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return

    const onTouchMove = (e: TouchEvent) => {
      let el = e.target as HTMLElement | null
      while (el && el !== document.body) {
        if (canScrollVertically(el) || canScrollHorizontally(el)) {
          return // 시트 내부 스크롤 영역(세로 목록·가로 사진 캐러셀 등) → 허용
        }
        el = el.parentElement
      }
      if (e.cancelable) {
        e.preventDefault() // 배경 스크롤 차단
      }
    }

    document.addEventListener('touchmove', onTouchMove, { passive: false })
    return () => {
      document.removeEventListener('touchmove', onTouchMove)
    }
  }, [active])
}
